<div> 
    <app-analise-venda-bi01-filtro
          [filtros]="filtros">
    </app-analise-venda-bi01-filtro>
    <app-analise-venda-bi01-lista
          [filtros]="filtros"
          (definirFiltro)="definirFiltro()"
          (exibir)="selecionar($event)">
    </app-analise-venda-bi01-lista>
   </div>